import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { isObject } from 'lodash';
import { IrisUserSettingsI } from '../modules/grid-configuration/models/grid-configuration.settings';

@Injectable({
  providedIn: 'root',
})
export class IrisUserSettingsService {
  private readonly httpClient = inject(HttpClient);

  getUserSettingsById<T = IrisUserSettingsI<never>>(alias: string, userId: number | string = 'default'): Observable<T> {
    return this.httpClient.get<T & { userId: number | string; id: number | string | null }>(`/user-settings/${alias}/${userId}`).pipe(
      map(result => {
        if (result.userId !== userId && userId !== 'default') {
          result.id = null;
        }
        return result;
      }));
  }

  saveUserSettings<T = IrisUserSettingsI<never>>(alias: string, userId: number, settings: T): Observable<T> {
    return this.httpClient.post<T>(`/user-settings/${alias}/${userId}`, settings);
  }

  clearUserSettings<T = IrisUserSettingsI<never>>(alias: string, userId: number): Observable<T> {
    return this.httpClient.delete<T>(`/user-settings/${alias}/${userId}`);
  }

  getEmailSignature(userId: number): Observable<string> {
    return this.getUserSettingsById('user-email-signature', userId).pipe(
      filter(userSettings => !!userSettings),
      map(({ settings }) => isObject(settings) ? '' : settings),
    );
  }
}
